<template>
    <errors>
            <img src="@/assets/images/404.png" alt="graphic-404" class="mx-auto mb-4 max-w-full">
            <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color text-center">404</h1>
            <vs-button
                    size="large"
                    to="/"
                    :active="active == 1"
                    @click="active = 1"
            >
                صفحه اصلی
            </vs-button>
    </errors>
</template>
<script>
    import errors from '@/components/layouts/errors'
    export default {
        components:{
            errors
        },
        data:() => ({
            active: 0
        })
    }
</script>